import FormGenerateTemplate from './FormGenerateTemplate';



export default FormGenerateTemplate;
